// Runs deferred, in document order right after jquery-3.6.4.min.js.
// Replays $()/jQuery() calls that inline scripts queued via the head shim
// (see layout/theme.liquid). Callbacks go through the real jQuery, which
// defers them to DOMContentLoaded — after slick/magnify (also deferred) load.
(function () {
  var queue = window.__jqQueue;
  if (!queue || !window.jQuery || window.jQuery.__shim) return;
  queue.forEach(function (fn) {
    window.jQuery(fn);
  });
  window.__jqQueue = [];
})();
